<template>
    <div class="col-md-4 col-lg-4 col-xl-4 col-xs-12 col-sm-12 q-mx-auto">
        <q-card flat class="bg-grey-2 q-pb-sm">
            <q-card-section class="q-pa-xs">
                <q-item bordered class="q-px-none">
                    <q-item-section avatar class="q-px-xs">
                        <q-icon size="lg" v-if="plan.isFree" name="img:/assets/icons/free-dig.svg" />
                        <q-icon size="lg" v-else name="img:/assets/icons/premium-dig.svg" />
                    </q-item-section>

                    <q-item-section>
                        <q-item-label class="text-left text-h6 text-secondary text-bold">{{plan.name}}</q-item-label>
                        <q-item-label caption class="text-left text-caption" lines="2">{{plan.description}}</q-item-label>
                    </q-item-section>

                    <q-item-section side top class="q-px-none">            
                        <div class="text-subtitle1" v-if="plan.isFree">
                            <strong class="text-secondary text-h6 q-pa-sm"> $ 0</strong>
                        </div>
                        <div class="text-subtitle1" v-else>
                            <strong class="text-secondary text-h6"> $ {{plan.price}}</strong>/mo
                        </div>
                    </q-item-section>
                </q-item>
            </q-card-section>
            <q-card-section class="q-px-md q-gutter-sm" horizontal>
                <q-icon size="sm" name="img:/assets/icons/scan-dig.svg" />
                <div class="text-subtitle1" >
                <strong>{{plan.scansIncluded}}</strong> scans / month
                </div>
            </q-card-section>
            <q-card-section class="q-px-md q-gutter-sm" horizontal>
                <q-icon size="sm" name="img:/assets/icons/feature-dig.svg" />
                <div class="text-subtitle1" v-if="plan.isFree">
                Basic Features
                </div>
                <div class="text-subtitle1" v-else>
                Premium Features (coming soon)
                </div>
            </q-card-section>
            <q-card-section horizontal class="q-mx-xs q-my-md q-gutter-x-md">
                <q-btn color="grey" padding="xs lg" size="md" v-if="plan.current" disable>
                    Current
                </q-btn>

                <q-btn color="primary" v-if="!plan.current && !plan.isFree" @click="upgrade(plan)">
                    Upgrade
                </q-btn>
                <a flat v-if="!plan.current && !plan.isFree" class="normal-link flex flex-center purple-link">
                    Cancel anytime
                </a>
                <div v-if="plan.current && !plan.isFree">
                    <p class="q-my-none text-left"><a flat class="normal-link purple-link" @click="cancel = true">
                    Cancel subscription
                    </a></p>
                    <p class="q-my-none text-left"><a flat class="normal-link purple-link" @click="dialog = true">
                    View history
                    </a></p>
                </div>
            </q-card-section>
        </q-card>

        <confirmation-dialog :subscription="plan.subscription" :confirm="cancel" />
        <billing-history-dialog v-if="dialog" :subscription="plan.subscription" />
    </div>
</template>
<script>
import { ref } from '@vue/reactivity'
import BillingHistoryDialog from "@/components/BillingHistoryDialog"
import ConfirmationDialog from "@/components/ConfirmationDialog"
export default {
    name: "plan-card",
    props: ['plan', 'upgrade'],
    components: {BillingHistoryDialog, ConfirmationDialog},
    setup () {
        const dialog = ref(false)
        const cancel = ref(false)

        return {dialog, cancel}
    }
}
</script>
<style scoped>
.purple-link {
    color: #6645EB;
}
</style>
